import PopupProvider from '../../../../../providers/PopupProvider';
import action from '../../../abstract/action.js';

const handle = async (
  {
    item,
  },
) => {
    PopupProvider.setContent({
      title: item.name || '',
      content: item.content || '',
      type: 'MANUAL'
    });
    PopupProvider.setIsActive(true);
};

export default action({
  label: 'Podgląd',
  icon: 'FileIcon',
  main: () => true,
  handle,
});
